/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Tab, Dropdown } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
// import { ReactComponent as CompilingIcon } from "../../../_metronic/layout/assets/layout-svg-icons/Compiling.svg";
import BadgeIcon from "../icon/BadgeIcon";
import SettingsIcon from "@material-ui/icons/Settings";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import ThemeButton from "../button/ThemeButton";
import ThemeHeader from "../content/ThemeHeader";
import { Link, useHistory } from "react-router-dom";
import {
  getAllNotification,
  getNotificationsUndeleted,
  getUnseenNotificationNumber,
  markNotificationAsUserDeleted,
  markAllNotificationsAsUserDeleted,
} from "../../GeneralApi/GeneralApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
// import { Waypoint } from "react-waypoint";
// import { Delete } from "@material-ui/icons";
import Swal from "sweetalert2";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

const UserNotifications = (props) => {
  const [items, setItems] = useState(null);
  const [otherResData, setOtherResData] = useState({});
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const [notification_number, setNotification_number] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      getUnseenNotificationNumber(user.id)
        .then(({ data }) => {
          setNotification_number(data);
        })
        .catch((error) => {
          if (error?.status === 401) {
            window.location.href = "/logout";
          }
        });

      if (notification_number > 0) {
        var snd = new Audio(
          "data:audio/wav;base64,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"
        );
        snd.play();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getUnseenNotificationNumber(user.id)
      .then(({ data }) => {
        setNotification_number(data);
      })
      .catch((e) => {
        // toast.error("Error while fetching");
      });
  }, []);

  const update = (query, fetchmore) => {
    getNotificationsUndeleted(query)
      .then((res) => {
        const { data, ...rest } = { ...res.data };
        if (fetchmore) {
          setItems([...items, ...data]);
        } else {
          setItems(data);
        }

        setOtherResData(rest);
      })
      .catch((e) => {
        toast.error("Error while fetching");
      });
    setNotification_number(0);
  };

  // const handleFetchMoreData = () => {
  //   if (otherResData?.current_page !== otherResData?.last_page) {
  //     let query = user.id + "&page=" + (otherResData?.current_page + 1);
  //     update(query, true);
  //   }
  // };

  // const getHeaderTopBarCssClassList = () => {
  //   let result = "kt-header__topbar-icon ";
  //   if (props.pulse) {
  //     result += "kt-pulse kt-pulse--brand ";
  //   }

  //   const { iconType } = props;
  //   if (iconType) {
  //     result += `kt-header__topbar-icon--${iconType}`;
  //   }

  //   return result;
  // };

  // const getSvgCssClassList = () => {
  //   let result = "kt-svg-icon ";
  //   const { iconType } = props;
  //   if (iconType) {
  //     result += `kt-svg-icon--${iconType}`;
  //   }

  //   return result;
  // };

  const getHetBackGroundCssClassList = () => {
    let result = "kt-head ";
    if (props.skin) {
      result += `kt-head--skin-${props.skin} `;
    }

    result += "kt-head--fit-x kt-head--fit-b";
    return result;
  };

  // const userNotificationsButtonCssClassList = () => {
  //   let result = "btn ";
  //   if (props.type) {
  //     result += `btn-${props.type} `;
  //   }

  //   result += "btn-sm btn-bold btn-font-md";
  //   return result;
  // };

  const ulTabsClassList = () => {
    let result = "nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x  ";
    if (props.type) {
      result += `nav-tabs-line-${props.type} `;
    }

    result += "kt-notification-item-padding-x";
    return result;
  };
  const handleClick = (item) => {
    document.body.click();
    if (item?.type == 1) {
      history.push("/dashboard");
    }
    if (item?.type == 2) {
      history.push("/listings/" + item?.what_id + "?subComponent=posts");
    }
    if (item?.type == 3) {
      history.push("/listings/" + item?.what_id + "/sales-advice", {
        listing: item?.what_id,
      });
    }
  };

  const handleClickDeleteNotification = async (item, index) => {
    let data = {};
    data.notification_id = item?.id;

    let status = await markNotificationAsUserDeleted(data);
    console.log("status = ", status);
    if (status.status === 200) {
      document.getElementById(`notification-list-item-${index}`).className =
        "d-none";
    }
    return false;
  };

  const handleClickDeleteAllNotifications = async (items) => {
    document.body.click();
    Swal.fire({
      title: "Do you want to delete ALL messages?",
      showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        markAllNotificationsAsUserDeleted().then((result) =>
          Swal.fire("Deleted!", "", "success")
        );
      } else if (result.isDenied) {
        Swal.fire("Did not delete", "", "info");
      }
    });

    return false;
  };

  const { pulse } = props;
  
  const WiseBerryAPIEnv = process.env.REACT_APP_WISEBERRY_API;
  const getEnv = () => {
    let currentEnv = WiseBerryAPIEnv.split("//");
    let innerVar;
    if (currentEnv.length > 1) {
      innerVar = currentEnv[1].split(".");
    }
    return innerVar;
  };

  // console.log('===========getEnv=========================');
  // console.log(getEnv()?.[0]);
  // console.log('=========getEnv===========================');

  return (
    <Dropdown className="kt-header__topbar-item" drop="down" alignRight>
      {/* Hide  on Production */}
    
        <Dropdown.Toggle
          as={HeaderDropdownToggle}
          id="dropdown-toggle-user-notifications"
        >
          <span
            onClick={() => update(user.id)}
            className={`kt-header__topbar-icon kt-pulse kt-pulse--warning`}
          >
            {notification_number > 0 ? (
              <>
                <BadgeIcon number={notification_number} />{" "}
                <span className="kt-pulse__ring" hidden={!pulse} />{" "}
              </>
            ) : (
              <BadgeIcon />
            )}
          </span>
        </Dropdown.Toggle>
    
      {/* Hide  on Production */}
      <Dropdown.Menu className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim p-0 dropdown-menu-xl">
        {/** Head */}
        <div
          className={
            getHetBackGroundCssClassList() + " p-0 darkBlue-background"
          }
        >
          <ThemeHeader
            className="p-3"
            leftclassName="pl-2"
            left={<h5 className="title darkGrey-color">Notifications </h5>}
            // right={
            //   <>
            //     <Link
            //       className="darkGrey-icon-button m-auto"
            //       to={`/notification_settings`}
            //     >
            //       {" "}
            //       <SettingsIcon />
            //     </Link>
            //     <ThemeButton
            //       icon
            //       className="darkGrey-icon-button"
            //       onClick={() => handleClickDeleteAllNotifications()}
            //     >
            //       {" "}
            //       <DeleteIcon />
            //     </ThemeButton>
            //   </>
            // }
          />
          <Tab.Container
            defaultActiveKey={"Notifications"}
            className={ulTabsClassList()}
          >
            <Tab.Content style={{ backgroundColor: "#fff" }} id="header-notification">
              <Tab.Pane eventKey="Notifications">
                <PerfectScrollbar
                  options={perfectScrollbarOptions}
                  style={{ maxHeight: "100vh", position: "relative" }}
                  // onYReachEnd={handleFetchMoreData}
                >
                  <div
                    className="kt-notification kt-margin-b-10"
                    style={{ maxHeight: "40vh", position: "relative" }}
                  >
                    <div
                      className="kt-notification  kt-margin-b-10 kt-scroll"
                      data-scroll="true"
                      data-height="300"
                      data-mobile-height="200"
                    >
                      {items
                        ? items.map((item, index) => (
                            <div
                              className="kt-notification__item  darkGrey-border-left"
                              id={`notification-list-item-${index}`}
                            >
                              <div>
                                <ThemeButton
                                  icon
                                  className="darkGrey-icon-button mr-2"
                                  onClick={() =>
                                    handleClickDeleteNotification(item, index)
                                  }
                                >
                                  <DeleteIcon />
                                </ThemeButton>
                              </div>
                              <a
                                className="kt-notification__item-details"
                                onClick={() => handleClick(item)}
                              >
                                <div className="kt-notification__item-title">
                                  {item.description}
                                </div>
                                <div className="kt-notification__item-time">
                                  {moment(item.created_at).fromNow()}
                                </div>
                              </a>
                            </div>
                          ))
                        : ""}
                    </div>{" "}
                  </div>
                </PerfectScrollbar>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserNotifications;
